import React, { useState, useEffect, useRef } from "react";
import { DataGrid } from "@material-ui/data-grid";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { FormCreateTeamDialog } from "../components/teams/FormCreateTeamDialog";
import { DialogRequestTeam } from "../components/teams/DialogRequestTeam"
import { TeamHome } from "../components/teams/TeamHome";
import { RankingTeams } from "../components/teams/RankingTeams";

import { LinearProgress } from "@material-ui/core";
import { Button} from '@mui/material';
import { pDB_user_roles } from "../utils/parameters";

import GroupAddIcon from '@mui/icons-material/GroupAdd';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import UndoIcon from "@mui/icons-material/Undo";
import Tooltip from '@mui/material/Tooltip';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../components/utils/DeviceQueries";
import SchoolIcon from '@mui/icons-material/School';
import device from "current-device";

import CountdownTimerDialog from "../components/utils/CountdownTimerDialog";
import DeviceReportDialog from "../components/utils/DeviceReportDialog";

import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import HealingIcon from '@mui/icons-material/Healing';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';



import "../styles/devices/mob_Teams.css";


export function Teams() {
  const { t } = useTranslation("global")

  /* Dialog */
  const { token_id, currentUser, currentUserRole } = useDataProvider();
  const { comm_createTeam, comm_acceptInvitationMemberTeam, comm_requestInvitationMemberTeam, comm_getInfoMemberTeam, comm_cancelInvitationMemberTeam, comm_updateTaskTeam} = useCommProvider();
  const [ snack, setSnack ] = useState({ open: false, text: "" });
  const [ pageSize, setPageSize ] = useState(10);
  const [ createTeamForm_openDialog, setCreateTeamForm_openDialog ] = useState(false);
  const [ requestTeam_openDialog, setRequestTeam_openDialog ] = useState(false);
  const [ loading, setLoading ] = useState(true)

  const [ team_id_selected, setTeam_id_selected ] = useState('')
  const [ task_id_selected, setTask_id_selected ] = useState('')
  const [ infoMemberTeam, setInfoMemberTeam ] = useState({})
  const [ rows, setRows ] = useState([]);
  const [ showRanking, setShowRanking ] = useState(false)
  const [ isLoadingDataGrid, setIsLoadingDataGrid ] = useState(true);
  // const [ isAdmin, setIsAdmin ] = useState(false)
  const isAdmin = useRef(false); 
  const [ openCountdownTimer, setOpenCountdownTimer ] = useState(false)
  const [ openDeviceReportDialog, setOpenDeviceReportDialog ] = useState(false)


  /* MOB - Nav responsiveness */
  const queryMatches = DeviceQueries();


  /* BUG REPORT TABLE */
  const [columns, setColumns] = useState([
    { field: "id", headerName: t("sTeams.table_field_name"), renderCell: (params) => gridTeamAccessID(params), sortable: false, flex: 1, headerAlign: 'left', disableColumnMenu: true  },
    { field: "label", headerName: t("sTeams.table_field_label"), cellClassName: 'sig_Teams_DG_Label', renderCell: (params) => gridTeamAccessTags(params), sortable: false, flex: 1, headerAlign: 'left', disableColumnMenu: true  },
    { field: "accesible", headerName: t("sTeams.table_field_permissions"), sortable: false, flex: 0.6, renderCell: (params) => gridTeamAccessStatus(params), headerAlign: 'left', disableColumnMenu: true },
    { field: "action", headerName: t("sTeams.table_field_action"), sortable: false, flex: 0.6, align: "center", renderCell: (params) => gridTeamAccessActions(params), headerClassName: 'sig_Teams_DG_HeaderLastColumn', headerAlign: 'center', disableColumnMenu: true  },
  ]);

  function gridTeamAccessID(params) {
    return <span>{params.row.id}</span>
  }

  function gridTeamAccessTags(params) {
    return <span>{params.row.label}</span>
  }

  function gridTeamAccessStatus(params) {
    let status = 'None'
    if (params.row.admin === true) {
      status = 'Administrador'
    }else if (params.row.accesible === true) {
      status = 'Accesible'
    }else if (params.row.request_admin === true) {
      status = 'Pendiente'
    }else if (params.row.request_user === true) {
      status = 'Pendiente'
    }
    return <span>{status}</span>
  }

  function gridTeamAccessActions(params) {
    if (params.row.admin === true || params.row.accesible === true) {
      if (params.row.closed === false ){
        return <Button className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug sig_Teams_MainButton" onClick={() => handleClickEnter(params.row.id)}> {t("strButton.btn_enter").toUpperCase()} </Button>
      } else{
        return <Button style={{backgroundColor: 'red', color:'white'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug sig_Teams_MainButton" onClick={() => setTeam_id_selected(params.row.id)} > {t("strButton.btn_closed").toUpperCase()} </Button>
      }
    }else if (params.row.request_admin === true){
        return <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2px'}}>
            <Button style={{backgroundColor: 'green'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug sig_Teams_MainButton" onClick={() => handleClickAcceptInvitation(params.row.id)}> {t("strButton.btn_accept").toUpperCase()} </Button>
            <Button style={{backgroundColor: 'red'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug sig_Teams_MainButton" onClick={() => handleClickCancelInvitation(params.row.id)}> {t("strButton.btn_cancel").toUpperCase()} </Button>
        </div>
    }else if (params.row.request_user === true){
      return <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2px'}}>
          <Button style={{backgroundColor: 'red'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug sig_Teams_MainButton" onClick={() => handleClickCancelInvitation(params.row.id)}> {t("strButton.btn_cancel").toUpperCase()} </Button>
      </div>
  }
  }

  function handleClickEnter(row_id){
    // if (isAdmin.current === true){
      setTeam_id_selected(row_id)
    // }
    // setOpenCountdownTimer(true)
  }

  function handleClickShowClasification(){
    // setOpenCountdownTimer(true)
    // console.log('Click handleClickShowClasification')
    setTeam_id_selected('ALL')
    setShowRanking(true)
  }


  
  useEffect(() => {
    // console.log("🚀 ~ file: Teams.js:107 ~ Teams ~ infoMemberTeam:", infoMemberTeam)
    if (Object.keys(infoMemberTeam).length !== 0) {
      setRows(infoMemberTeam['status_teams'])
      setIsLoadingDataGrid(false)
      setLoading(false)
    }else{
      setLoading(true)
    }
  }, [infoMemberTeam]);

  useEffect(() => {
    isAdmin.current = [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin].includes(currentUserRole)
  }, [infoMemberTeam, currentUserRole]);

  // useEffect(() => {
  //   console.log("🚀 ~ file: Teams.js:124 ~ Teams ~ isAdmin:", isAdmin.current)
  // }, [isAdmin.current]);


  useEffect(() => {
    async function getTeamsList() {
      setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
    }

    getTeamsList()
    return () => {
      setInfoMemberTeam([])
      setIsLoadingDataGrid(true)
    }
  }, []);
  

  function handleClickCreateTeam() {
    setCreateTeamForm_openDialog(true)
  }

  function handleClickRequestTeam() {
    setRequestTeam_openDialog(true)
  }

  async function handleClickAcceptInvitation(team_id) {
    await comm_acceptInvitationMemberTeam(token_id, currentUser, team_id)
    setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
  }

  async function handleClickRequestInvitation(team_id) {
    try{
      await comm_requestInvitationMemberTeam(token_id, currentUser, team_id)
      setSnack({ ...snack, open: true, text: t("sTeams.request_team")+': '+ team_id, type: "info" });
      setRequestTeam_openDialog(false)
    }catch{
      setSnack({ ...snack, open: true, text: t("sTeams.request_team_incorrect"), type: "error" });
    }
    setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
  }
  
  async function handleClickCancelInvitation(team_id) {
    await comm_cancelInvitationMemberTeam(token_id, currentUser, team_id)
    setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
  }

  function handleClickEnterTeamHome(team_id) {
    setTeam_id_selected(team_id)
  }


  async function sendFormCreateTeam(data) {
    // console.log('sendFormCreateTeam')
    // console.log(data)
    try{
      await comm_createTeam(token_id, currentUser, data);
      setCreateTeamForm_openDialog(false)
      setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
      setSnack({ ...snack, open: true, text: 'Equipo creado', type: "info" });
    }catch(e){
      console.error(e)
      setSnack({ ...snack, open: true, text: 'Identificador no valido', type: "error" });
    }
  }

  async function returnMenu(){
    // console.log("🚀 ~ file: Teams.js:184 ~ returnMenu ~ returnMenu:", returnMenu)
    setTeam_id_selected("")
    setShowRanking(false)
    setInfoMemberTeam(await comm_getInfoMemberTeam(token_id, currentUser))
  }

  // function currentUserRolePermission(){
  //   console.log("🚀 ~ file: Teams.js:192 ~ currentUserRolePermission ~ currentUserRolePermission:", [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin].includes(currentUserRole))
    
  //   return [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin].includes(currentUserRole);
  // }

  const location = useLocation();
  useEffect(() => {

    async function append_into_users_activity(task_id, data_in) {
      await comm_updateTaskTeam(token_id, currentUser, task_id, data_in)
    }

    if (location.team_id !== undefined) {
      if (location.video_sent){
        const data_in = {
          "add": true,
          "element_id": location.gloss,
          "record_id" : location.record_id
        }
        append_into_users_activity(location.task_id, data_in)
        
      }else{
        console.log('RETURN - VIDEO - TASK: ', location.task_id)

      }
      setTeam_id_selected(location.team_id)
      setTask_id_selected(location.task_id)

    }
  }, [location]);

  function showTutorial(){
    // console.log("🚀 ~ file: Teams.js:215 ~ showTutorial ~ showTutorial:", showTutorial)
    const URL = 'https://efficient-check-bb3.notion.site/d681770038ef40ad8f53d83478dad8dd?v=f7a80a3c213d4d298a71b6d0d8be1afa'
    window.open(URL, "_blank", "noopener,noreferrer");
  }

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const sendEmail2 = () => {

    // console.log('CURRENTUSER ', currentUser)
    // console.log('CURRENTUSER EMAIL', currentUser.uid)
    // console.log('CURRENTUSER UID', currentUser.email)

    const email = 'signamed@uvigo.es';
    const subject = encodeURIComponent('Solicitud Perfil de Docente');
    
    const body = encodeURIComponent(
        `SOLICITUD PARA CONFIGURAR CUENTA COMO PERFIL DE DOCENTE\n\n` +
        `=====================================================\n\n` +
        `Mi centro es: [Insertar nombre del centro educativo]\n\n\n\n` +

        `INFORMACIÓN ADJUNTA A LA PETICIÓN (No editar ni borrar)\n` +
        `----------------------------------\n` +
        `ID: ${currentUser.uid}\n` +
        `Email: ${currentUser.email}\n\n\n\n` +

        `=====================================================\n\n` +
        `El equipo de Signamed revisará su caso con la mayor brevedad posible. Gracias\n`

    );

    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
};

const sendEmail = () => {
  // console.log('CURRENTUSER ', currentUser)
  // console.log('CURRENTUSER EMAIL', currentUser.uid)
  // console.log('CURRENTUSER UID', currentUser.email)

  const email = 'signamed@uvigo.es';
  const subject = encodeURIComponent('Solicitud Perfil de Docente');
  
  const body = encodeURIComponent(
      `SOLICITUD PARA CONFIGURAR CUENTA COMO PERFIL DE DOCENTE\n\n` +
      `Mi centro es: [Insertar nombre del centro educativo]\n\n` +
      `INFORMACIÓN ADJUNTA A LA PETICIÓN (No editar ni borrar)\n` +
      `ID: ${currentUser.uid}\n` +
      `Email: ${currentUser.email}\n\n` +
      `El equipo de Signamed revisará su caso con la mayor brevedad posible. Gracias\n`
  );

  const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
  // console.log('Mailto link:', mailtoLink); // Para depuración

  window.location.href = mailtoLink;
};

function showConfigRecomendations(){
  // console.log("🚀 ~ file: Teams.js:215 ~ showTutorial ~ showTutorial:", showTutorial)
  const URL = 'https://efficient-check-bb3.notion.site/4739616945134257b9a64ab98ab2d9cf?pvs=25#79e39d1e607c43229b5ecab6fd12c52e'
  window.open(URL, "_blank", "noopener,noreferrer");
}


  
  return (
    <HomeWrapper>
        <PageTitle title= {t("sTeams.title")} />
        
        <Button onClick={showTutorial} className={`sig_Collab_Teams_ReturnButton sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode ${(queryMatches.deviceLandscape || queryMatches.deviceLarge) ? 'sig_Teams_FixedButtonsCorrection' : ''}`} variant="contained">
            <LiveHelpIcon className="sig_Collab_UndoIcon" /> <span className="sig_Collab_Teams_ReturnButton_Label"> Tutorial </span>
        </Button>

        {team_id_selected === '' ? (
            <>

              <div className="sig_BugReport_ButtonsContainer">
                <Button className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={handleClickShowClasification}>
                  <EmojiEventsIcon className="sig_VersusMachine_Start_Icon" fontSize="large"/> {t("sTeams.btn_show_ranking").toUpperCase()}
                </Button>
                

                {isAdmin.current ? (
                  <>
                    <span>
                    <Button className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={handleClickCreateTeam}>
                      <GroupAddIcon className="sig_VersusMachine_Start_Icon" fontSize="large"/> {t("sTeams.btn_create_team").toUpperCase()}
                    </Button>
                    </span>
                  </>
                ):
                <>
                  <Button className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={handleClickRequestTeam}>
                    <SwitchAccountIcon className="sig_VersusMachine_Start_Icon" fontSize="large"/> {t("sTeams.btn_request_team").toUpperCase()}
                  </Button>
                
                </>}

              </div>  
            
            {loading ? <LinearProgress color="primary" />
            
            :

            <>

            <div className="sig_ST_Root"> 
                <HelpSnackbar snack={snack} setSnack={setSnack} />
                <div className="sig_Teams_DG_Container">
                    <DataGrid
                        className="sig_Teams_DG"
                        autoHeight
                        pageSize={pageSize}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        disableSelectionOnClick
                        pagination
                        loading={isLoadingDataGrid}
                        columns={columns}
                        rows={rows}
                        localeText={{footerRowPerPage: "Rows per page"}}
                    />
                </div>
            </div>
            

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button className="sig_SignDialog_Button" style={{ marginTop: '5px', maxWidth: '90%' }} onClick={showConfigRecomendations} variant="contained">
                <LiveHelpIcon className="sig_Collab_UndoIcon" /> 
                <span>{t("sTeams.btn_help_student")}</span>
              </Button>
            </div>

            { isAdmin.current === false && 
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button className="sig_SignDialog_Button" style={{ marginTop: '5px', maxWidth: '90%', backgroundColor: '#ed2f6e' }} onClick={sendEmail} variant="contained">
                        <SchoolIcon className="sig_Collab_UndoIcon" /> 
                        <span>{t("sTeams.btn_help_teacher")}</span>
                    </Button>
              </div>
            }

            </>
            
          
            }         
      
            </>
        ) : (
          <>
            <Button onClick={returnMenu} className={`sig_Main_IconButton ${showRanking? 'sig_Teams_ReturnButton' : 'sig_Teams_ReturnButton_White'} ${(queryMatches.deviceLandscape || queryMatches.deviceLarge) ? 'sig_Teams_FixedButtonsCorrection' : ''} sig_Home_ChangeOnDarkMode`} variant="contained">
              <UndoIcon/>
            </Button>
            {(showRanking === false) 
            ? <TeamHome team_id_selected={team_id_selected} task_id_selected={task_id_selected} setTask_id_selected={setTask_id_selected} returnMenu={returnMenu}/>
            : <RankingTeams showRanking={showRanking}/>}
          </>
        )}


        
        
      <DialogRequestTeam openDialog={requestTeam_openDialog} setOpenDialog={setRequestTeam_openDialog} handleClickRequestInvitation={handleClickRequestInvitation} infoMemberTeam={infoMemberTeam}/>
      <FormCreateTeamDialog openDialog={createTeamForm_openDialog} setOpenDialog={setCreateTeamForm_openDialog} sendFormCreateTeam={sendFormCreateTeam} />

      <CountdownTimerDialog open={openCountdownTimer} setOpen={setOpenCountdownTimer} timestampStart={1702886400000} isAdmin={isAdmin}/>
      {/* <DeviceReportDialog open={openDeviceReportDialog} setOpen={setOpenDeviceReportDialog}/> */}

    </HomeWrapper>
  );
}
